import { useIsMac } from "../../lib/useIsMac.ts";

/**
 * A prominent, input-looking button that opens the ⌘K command palette.
 * It isn't a real input — focus/typing happen in the palette — but it reads
 * as the primary way to search the desk. Platform-aware modifier hint.
 */
export function SearchBar({ className = "" }: { className?: string }) {
  const isMac = useIsMac();

  const open = () => window.dispatchEvent(new Event("cmdk:open"));

  return (
    <button
      type="button"
      className={`search-bar${className ? ` ${className}` : ""}`}
      onClick={open}
      aria-label="Search the vault, prompts and ritual"
    >
      <span className="search-bar-icon" aria-hidden="true">
        ⌕
      </span>
      <span className="search-bar-text">Search the vault, prompts &amp; ritual…</span>
      <span className="search-bar-keys" aria-hidden="true">
        <kbd>{isMac ? "⌘" : "Ctrl"}</kbd>
        <kbd>K</kbd>
      </span>
    </button>
  );
}
